<template>
  <div class="expert-top" style="min-height:35vw">
    <div class="container clearf">
      <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/expert' }"
            >农业专家</el-breadcrumb-item
          >
          <el-breadcrumb-item>专家详情</el-breadcrumb-item>
        </el-breadcrumb>
        <ul class="expert-lists">
          <li class="expert-destwo">
            <img v-if="respData.coverUrl" :src="$img + respData.coverUrl" />
            <img v-else src="../assets/expert-default.png" />
            <ul class="ul-right">
              <li>
                <span class="txt">姓名:</span>
                <span>{{ respData.realname }}</span>
              </li>
              <li>
                <span class="txt">专家组:</span>
                <span>{{ respData.category }}</span>
              </li>
              <li>
                <span class="txt">职务/职称:</span>
                <span>{{ respData.jobTitle }}</span>
              </li>
              <li>
                <span class="txt">学历:</span>
                <span>{{ respData.education }}</span>
              </li>
              <li>
                <span class="txt">工作单位:</span>
                <span>{{ respData.company }}</span>
              </li>
            </ul>
          </li>
          <div class="expertss">
            <p>专家简介:</p>
            <span>{{ respData.introduction }}</span>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      respData: ""
    };
  },
  mounted(e) {
    console.log(this.$route.query);
    this.tid = this.$route.query.tid;
    this.expertPage();
  },
  methods: {
    expertPage(e) {
      let id = this.tid;
      this.$api.experApi
        .expertInfo({ id })
        .then(res => {
          console.log("专家详情=>", res);
          this.respData = res.data.respData;
        })
        .catch(err => {
          console.log("err=>", err);
        });
    }
  }
};
</script>
<style lang="less">
.expert-top {
  margin-top: 20px;
}
.expert-destwo {
  width: 100%;
  padding: 20px 20px 0 20px;
  margin-top: 20px;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  img {
    width: 150px;
    height: 180px;
    background-color: #f0f0f0;
    object-fit: contain;
  }
  .ul-right {
    width: 600px;
    padding-left: 20px;
    padding-top: 5px;
    li {
      display: -webkit-flex;
      -webkit-justify-content: flex-start;
      -moz-justify-content: flex-start;
      -o-justify-content: flex-start;
      -webkit-align-items: flex-start;
      -moz-align-items: flex-start;
      -o-align-items: flex-start;
      padding-bottom: 15px;
      .txt {
        // width: 100px;
        margin-right: 10px;
        color: rgb(153, 153, 153);
      }
      .txt-brief {
        width: 550px;
      }
    }
  }
}
.expert-lists {
  background: #fff;
  padding-bottom: 20px;
}
.expertss {
  width: 96%;
  padding: 20px;
  margin: 0 0 0 20px;
  background: rgb(246, 246, 246);
  p {
    margin-bottom: 15px;
    font-weight: bold;
  }
  span {
    color: #333;
  }
}
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508;
}
.el-breadcrumb__separator {
  color: #333;
}
.left-box {
  float: left;
  width: 848px;
  margin-top: 20px;
}
.right-box {
  float: right;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/expertDetail.vue